// LMBNCForm.js
import React, { useState, useMemo, useEffect } from "react";
import "./LMBNCForm.css";
import { useEtatGlobal } from "../../../EtatGlobal.js";
import TabelauBNC from "./BNCTableau.js";
// import { IoSearchSharp } from "react-icons/io5";
import { User, Building2, ChevronDown, Check, Calendar } from "lucide-react";
import { Input } from "../../../../components/ui/input.js";
import { Select } from "../../../../components/ui/select.js";
import { Textarea } from "../../../../components/ui/textArea.js";
import CabinetSelect from "../../components/CabinetSelect";
import SelectOuAutre from "../../components/SelectOuAutre";
import {
  FORME_SOCIALE_OPTIONS,
  CIVILITE_OPTIONS,
  EFFECTIF_OPTIONS,
  ORGANISATION_COMPTABLE_OPTIONS,
} from "../../components/lmSelectOptions";

function LMBNCForm({
  handleInputChange,
  handleDateClotureChange,
  handleCheckboxChangeTabeleau,
  handleCheckboxChangeDevis,
  setDetailsMission,
  setDetailsHonoraire,
  handleCheckboxChange,
}) {
  // const [showPeriodicity, setShowPeriodicity] = useState(false);
  const { formData, setFormData } = useEtatGlobal();
  // const [numSiret, setNumSiret] = useState("");
  // const [isLoading, setIsLoading] = useState(false);

  const [visible, setVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenMission, setIsOpenMission] = useState(true);

  // Initialisé depuis formData.champ_libre (global, persiste au-delà du
  // montage du formulaire) plutôt que toujours false : sans ça, revenir de
  // /Visuel remonte ce composant avec la case décochée alors que le texte
  // saisi est toujours là dans formData — juste caché.
  const [showTextarea, setShowTextarea] = useState(() => {
    const val = formData.champ_libre;
    return typeof val === "string" && val.trim() !== "";
  });

  // const handleNumSiretChange = (e) => {
  //   setNumSiret(e.target.value);
  // };

  // const handleSearchSiret = async () => {
  //   if (numSiret.length !== 14) {
  //     dialog.alert("Le numéro SIRET doit contenir 14 chiffres.");
  //     return;
  //   }

  //   try {
  //     setIsLoading(true);
  //     const response = await fetch(
  //       `https://backend-myalfa.vercel.app/api/siret/${numSiret}`
  //     );
  //     const data = await response.json();
  //     if (data.success) {
  //       const {
  //         siren,
  //         denominationUniteLegale,
  //         sexeUniteLegale,
  //         adresse,
  //         nomUniteLegale,
  //         prenomUsuelUniteLegale,
  //       } = data;

  //       setFormData((prev) => ({
  //         ...prev,
  //         siren: siren || "",
  //         nom_client: denominationUniteLegale || "",
  //         adresse: adresse
  //           ? `${adresse.numeroVoie || ""} ${adresse.typeVoie || ""} ${
  //               adresse.libelleVoie || ""
  //             }, ${adresse.codePostal || ""} ${adresse.libelleCommune || ""}`
  //           : "",
  //         nom: nomUniteLegale || "",
  //         prenom: prenomUsuelUniteLegale || "",
  //         civilite_lm: sexeUniteLegale === "F" ? "Madame" : "Monsieur",
  //       }));
  //     } else {
  //       dialog.alert("Aucune donnée trouvée pour ce numéro SIRET.");
  //     }
  //   } catch (error) {
  //     console.error("Erreur lors de la recherche SIRET :", error);
  //     dialog.alert("Erreur lors de la recherche. Vérifiez le serveur.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const isValid = useMemo(() => {
    // liste des champs à vérifier
    // "adresse" n'est pas obligatoire — nullable, laissée vide dans le LM
    // généré si non renseignée.
    const requiredFields = [
      "nom_client",
      "lieu_collab",
      "acticite_principale",
      "effectif",
      "volumes_annuels",
      "nom",
      "prenom",
      "email",
      "telephone",
    ];

    // retourne true seulement si tous les champs sont remplis (non vides)
    return requiredFields.every((field) => {
      const value = formData[field];
      return (
        value !== " " && value !== null && value !== undefined && value !== ""
      );
    });
  }, [formData]);

  const isValidHonoraire = useMemo(() => {
    const missions = [formData.mission_comptables];
    const isAtLeastOneMissionChecked = missions.some(
      (mission) =>
        mission !== "☐" &&
        mission !== "" &&
        mission !== null &&
        mission !== undefined
    );
    return isAtLeastOneMissionChecked;
  }, [formData]);

  const isValidMission = useMemo(() => {
    // Vérifie les champs obligatoires simples
    const requiredFields = ["date_debut", "date_fin"];
    const areRequiredFieldsFilled = requiredFields.every((field) => {
      const value = formData[field];
      return (
        value !== " " && value !== null && value !== undefined && value !== ""
      );
    });

    return areRequiredFieldsFilled;
  }, [formData]);

  useEffect(() => {
    if (isValidMission) {
      setDetailsMission(true);
    } else {
      setDetailsMission(false); // facultatif si tu veux réinitialiser quand invalide
    }
  }, [isValidMission, setDetailsMission]);

  useEffect(() => {
    if (isValidHonoraire) {
      setDetailsHonoraire(true);
    } else {
      setDetailsHonoraire(false); // facultatif si tu veux réinitialiser quand invalide
    }
  }, [isValidHonoraire, setDetailsHonoraire]);

  return (
    <div className="Container">
      <div>
        <div
          className="border-2 border-slate-200 rounded-xl bg-white overflow-hidden"
          style={{ padding: "10px" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="p-4 hover:bg-slate-50 transition-colors rounded-lg mb-5"
            onClick={() => setIsOpen(!isOpen)}
          >
            <div
              style={{
                display: "flex",
                gap: "25px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${
                  isValid
                    ? "bg-emerald-100 text-emerald-700"
                    : "bg-slate-100 text-slate-600"
                }`}
              >
                {isValid ? (
                  <Check className="w-5 h-5" />
                ) : (
                  <Building2 className="w-5 h-5" />
                )}
              </div>

              <h3
                className="font-semibold text-slate-800"
                style={{ margin: 0 }}
              >
                1. Votre entité
              </h3>
            </div>
            <ChevronDown
              className={`w-5 h-5 text-slate-400 transition-transform ${
                isOpen ? "rotate-180" : ""
              }`}
            />
          </div>
          {isOpen && (
            <div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="p-6 pt-0 space-y-6"
            >
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Forme sociale
                      </label>
                      <SelectOuAutre
                        name="forme_sociale"
                        value={formData.forme_sociale}
                        onChange={handleInputChange}
                        options={FORME_SOCIALE_OPTIONS}
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Nom du client
                      </label>
                      <Input
                        type="text"
                        name="nom_client"
                        value={formData.nom_client}
                        onChange={handleInputChange}
                        required
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    {/* <div
                          className="siret-search"
                          style={{
                            display: "flex",
                            gap: "20px",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <label>Recherche Siret</label>
                            <input
                              type="text"
                              name="NumSiret"
                              value={numSiret}
                              onChange={handleNumSiretChange}
                              required
                            />
                          </div>
      
                          <div
                            onClick={handleSearchSiret}
                            disabled={isLoading}
                            style={{
                              marginTop: "7.5%",
                              color: "white",
                              background: "#840040",
                              padding: "2px 7.5px",
                              borderRadius: "4px",
                              border: "none",
                              cursor: "pointer",
                            }}
                          >
                            {isLoading ? (
                              <div
                                style={{
                                  color: "white",
                                  width: "10px",
                                  height: "10px",
                                  border: "2px solid #ccc",
                                  borderTop: "2px solid #007BFF",
                                  borderRadius: "50%",
                                  animation: "spin 1s linear infinite",
                                }}
                              />
                            ) : (
                              <IoSearchSharp size={12} />
                            )}
                          </div>
                        </div> */}
                  </div>
                  <CabinetSelect />
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      Adresse
                    </label>
                    <Input
                      type="text"
                      name="adresse"
                      value={formData.adresse}
                      onChange={handleInputChange}
                      className="bg-white border-slate-200 h-9 text-sm"
                    />
                  </div>

                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      {" "}
                      <label className="text-slate-600 mb-1 block text-xs">
                        SIREN
                      </label>
                      <Input
                        type="text"
                        name="siren"
                        value={formData.siren}
                        maxLength="9"
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Activité Principale
                      </label>
                      <Input
                        type="text"
                        name="acticite_principale"
                        value={formData.acticite_principale}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Date de clôture
                      </label>
                      <div style={{ display: "flex", width: "100%" }}>
                        <Select
                          name="date_cloture_jour"
                          value={formData.date_cloture_jour}
                          onChange={handleDateClotureChange}
                        >
                          {[...Array(31).keys()].map((day) => (
                            <option
                              key={day}
                              value={String(day + 1).padStart(2, "0")}
                            >
                              {String(day + 1).padStart(2, "0")}
                            </option>
                          ))}
                        </Select>
                        <Select
                          name="date_cloture_mois"
                          value={formData.date_cloture_mois}
                          onChange={handleDateClotureChange}
                        >
                          {[
                            "Janvier",
                            "Février",
                            "Mars",
                            "Avril",
                            "Mai",
                            "Juin",
                            "Juillet",
                            "Août",
                            "Septembre",
                            "Octobre",
                            "Novembre",
                            "Décembre",
                          ].map((mois, index) => (
                            <option
                              key={index}
                              value={String(index + 1).padStart(2, "0")}
                            >
                              {mois}
                            </option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Effectif
                      </label>
                      <SelectOuAutre
                        name="effectif"
                        value={formData.effectif}
                        onChange={handleInputChange}
                        options={EFFECTIF_OPTIONS}
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Organisation comptable
                      </label>
                      <SelectOuAutre
                        name="organisation_comptable"
                        value={formData.organisation_comptable}
                        onChange={handleInputChange}
                        options={ORGANISATION_COMPTABLE_OPTIONS}
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Volumes annuels
                      </label>
                      <Input
                        type="text"
                        name="volumes_annuels"
                        value={formData.volumes_annuels}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <h4 className="font-semibold text-slate-700 mb-5 text-sm flex items-center gap-2">
                    <User className="w-4 h-4 text-[#8B1D41]" />
                    Contact Référent
                  </h4>
                  <div className="space-y-3">
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="text-slate-600 mb-1 block text-xs">
                          Civilité
                        </label>
                        <SelectOuAutre
                          name="civilite_lm"
                          value={formData.civilite_lm}
                          onChange={handleInputChange}
                          options={CIVILITE_OPTIONS}
                        />
                      </div>
                      <div>
                        <label className="text-slate-600 mb-1 block text-xs">
                          Nom
                        </label>
                        <Input
                          type="text"
                          name="nom"
                          value={formData.nom}
                          onChange={handleInputChange}
                          className="bg-white border-slate-200 h-9 text-sm"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Prénom
                      </label>
                      <Input
                        type="text"
                        name="prenom"
                        value={formData.prenom}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Email
                      </label>
                      <Input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Téléphone
                      </label>
                      <Input
                        type="text"
                        name="telephone"
                        value={formData.telephone}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <br />
        <div
          className="border-2 border-slate-200 rounded-xl bg-white overflow-hidden"
          style={{ padding: "10px" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="p-4 hover:bg-slate-50 transition-colors rounded-lg mb-5"
            onClick={() => setIsOpenMission(!isOpenMission)}
          >
            <div
              style={{
                display: "flex",
                gap: "25px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${
                  isValidMission && isValidHonoraire
                    ? "bg-emerald-100 text-emerald-700"
                    : "bg-slate-100 text-slate-600"
                }`}
              >
                {isValidMission && isValidHonoraire ? (
                  <Check className="w-5 h-5" />
                ) : (
                  <Calendar className="w-5 h-5" />
                )}
              </div>

              <h3
                className="font-semibold text-slate-800"
                style={{ margin: 0 }}
              >
                2. Notre mission
              </h3>
            </div>
            <div
              style={{
                display: "flex",
                gap: "25px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className="flex items-center gap-2"
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  name="avenant"
                  checked={formData.avenant === "☒"}
                  onChange={handleCheckboxChange}
                  className="bg-white border-slate-200 h-9 text-sm"
                />
                <label className="text-slate-600  block text-xs">Avenant</label>
              </div>

              <ChevronDown
                className={`w-5 h-5 text-slate-400 transition-transform ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </div>
          </div>
          {isOpenMission && (
            <div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="p-6 pt-0 space-y-6"
            >
              <div className="grid md:grid-cols-1 gap-6">
                <div className="grid grid-cols-4 gap-4">
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      Début de la mission
                    </label>
                    <Input
                      type="date"
                      name="date_debut"
                      value={
                        formData.date_debut
                          ? formData.date_debut.split("/").reverse().join("-")
                          : ""
                      }
                      onChange={handleInputChange}
                      className="bg-white border-slate-200 h-9 text-sm"
                    />
                  </div>
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      Fin de la mission
                    </label>
                    <Input
                      type="date"
                      name="date_fin"
                      value={
                        formData.date_fin
                          ? formData.date_fin.split("/").reverse().join("-")
                          : ""
                      }
                      onChange={handleInputChange}
                      className="bg-white border-slate-200 h-9 text-sm"
                    />
                  </div>
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      Expert-Comptable
                    </label>
                    <Select
                      name="expert_comptable_nom"
                      value={formData.expert_comptable_nom}
                      onChange={handleInputChange}
                    >
                      <option value="Samuel HOARAU">Samuel HOARAU</option>
                      <option value="Anthony HOARAU">Anthony HOARAU</option>
                    </Select>
                  </div>
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      Signataire
                    </label>
                    <Select
                      name="expert_comptable"
                      value={formData.expert_comptable}
                      onChange={handleInputChange}
                    >
                      <option value="Samuel HOARAU">Mrs Samuel HOARAU</option>
                      <option value="Anthony HOARAU">Mrs Anthony HOARAU</option>
                    </Select>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-6">
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="mission_comptables"
                        checked={formData.mission_comptables === "☒"}
                        onChange={handleCheckboxChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                      <label className="text-slate-600  block text-xs">
                        Missions comptables et fiscales
                      </label>
                    </div>
                  </div>
                  <div className="space-y-6">
                    <div className="flex items-center gap-2">
                      <label className="text-slate-600  block text-xs">
                        Honoraires Comptables
                      </label>
                      <Input
                        className="bg-white border-slate-200 h-9 text-sm"
                        type="text"
                        name="hono_compta_bnc"
                        placeholder="42,50"
                        value={formData.hono_compta_bnc.replace(" €", "")}
                        onChange={(e) => {
                          let raw = e.target.value
                            .replace(",", ".")
                            .replace(/[^\d.]/g, "");
                          if (raw === "") {
                            setFormData({ ...formData, hono_compta_bnc: "" });
                            return;
                          }

                          let num = parseFloat(raw);
                          if (!isNaN(num)) {
                            const parts = raw.split(".");
                            let formatted =
                              parts.length === 2
                                ? parts[0] + "," + parts[1].substring(0, 2)
                                : parts[0];
                            setFormData({
                              ...formData,
                              hono_compta_bnc: formatted,
                            });
                          }
                        }}
                        onBlur={() => {
                          let input = formData.hono_compta_bnc
                            .replace(",", ".")
                            .replace(/[^\d.]/g, "");
                          let num = parseFloat(input);
                          if (!isNaN(num)) {
                            let formatted = num.toFixed(2).replace(".", ",");
                            setFormData({
                              ...formData,
                              hono_compta_bnc: formatted,
                            });
                          } else {
                            setFormData({ ...formData, hono_compta_bnc: "" });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                {formData.avenant === "☒" && (
                  <div
                    style={{ width: "50%" }}
                    className="bg-slate-50 rounded-xl p-4 border border-slate-200"
                  >
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Date de la LM d'origine
                      </label>
                      <Input
                        type="date"
                        name="date_avenant"
                        value={
                          formData.date_avenant
                            ? formData.date_avenant
                                .split("/")
                                .reverse()
                                .join("-")
                            : ""
                        }
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    <br />
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Numéro de l'avenant
                      </label>
                      <Input
                        type="text"
                        name="numero_avenant"
                        value={formData.numero_avenant}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                  </div>
                )}

                <div style={{ width: "50%", marginTop: "0.5%" }}>
                  <div
                    style={{
                      marginBottom: "1px",
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <label className="text-slate-600 mb-1 block text-xs">
                      Ajouter un texte libre :
                    </label>
                    <Input
                      style={{ width: "5%" }}
                      type="checkbox"
                      checked={showTextarea}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setShowTextarea(checked);
                        // Décocher doit aussi vider champ_libre — sinon
                        // le texte saisi précédemment reste utilisé dans
                        // le document généré (texteFinal) même si la
                        // case n'est plus cochée et que rien n'est
                        // visible/saisi à l'écran.
                        if (!checked) {
                          handleInputChange({
                            target: { name: "champ_libre", value: "" },
                          });
                        }
                      }}
                      className="bg-white border-slate-200 h-4 text-sm"
                    />
                  </div>
                  {showTextarea && (
                    <Textarea
                      type="text"
                      name="champ_libre"
                      style={{ width: "100%", marginTop: "0.5%" }}
                      value={formData.champ_libre}
                      onChange={handleInputChange}
                      rows={3}
                    />
                  )}
                </div>

                <div style={{ width: "100%", marginTop: "0.5%" }}>
                  <label className="text-slate-600 mb-1 block text-xs">
                    Mission complémentaire
                  </label>
                  <Textarea
                    name="mission_complementaire"
                    value={formData.mission_complementaire}
                    placeholder=" - NEANT"
                    onChange={handleInputChange}
                    rows={4}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <br />
      <div
        className="border-2 border-slate-200 rounded-xl bg-white overflow-hidden"
        style={{ padding: "10px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="p-4 hover:bg-slate-50 transition-colors rounded-lg mb-5"
          onClick={() => setVisible(!visible)}
        >
          <div
            style={{
              display: "flex",
              gap: "25px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="w-10 h-10 rounded-lg flex items-center justify-center transition-colors bg-slate-100 text-slate-600">
              <Building2 className="w-5 h-5" />
            </div>
            <h3 className="font-semibold text-slate-800" style={{ margin: 0 }}>
              ANNEXE 2 - TABLEAU DE REPARTITION DES OBLIGATIONS
            </h3>
          </div>
          <ChevronDown
            className={`w-5 h-5 text-slate-400 transition-transform ${
              visible ? "rotate-180" : ""
            }`}
          />
        </div>
        {visible && (
          <TabelauBNC
            formData={formData}
            handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
            handleCheckboxChangeDevis={handleCheckboxChangeDevis}
          />
        )}
      </div>
    </div>
  );
}

export default LMBNCForm;
